import React from 'react'
import PropTypes from 'prop-types'
import styles from './style.module.scss'

import { Col, Row } from 'react-bootstrap'
import MyImage from '@shared/components/myImage'
import CustomLink from '@shared/components/customLink'
import { S3_PREFIX } from '@shared-submodule/sm-constants'
import TeamImage from '@assets/images/placeholder/team-placeholder.svg'

function TeamCards({ teamsList }) {
  return (
    <Row className='p-1'>
      {teamsList?.map((team) => {
        return (
          <Col id={team?._id} key={team?._id} sm={12} md={4} className='px-2'>
            {team?.oSeo?.sSlug ? <CustomLink href={'/' + team.oSeo.sSlug} prefetch={false}>
              <a className={`${styles.team} common-box d-flex`}>
                <div className={`${styles.teamLogo} mx-auto flex-shrink-0`}>
                  <MyImage
                    src={team?.oImg?.sUrl ? `${S3_PREFIX}${team?.oImg?.sUrl}` : TeamImage}
                    alt={team?.sAbbr}
                    placeholderImage={TeamImage}
                    width={40}
                    height={40}
                    layout="responsive"
                    errorImage={TeamImage}
                  />
                </div>
                <div className="flex-grow-1">
                  <h6 className={`${styles.name} font-bold`}>{team?.sTitle}</h6>
                  <span className={`${styles.caption} font-bold`}>{team?.sCountryFull}</span>
                </div>
              </a>
            </CustomLink> : <div className={`${styles.team} common-box d-flex align-items-center`}>
              <div className={`${styles.teamLogo} mx-auto flex-shrink-0`}>
                <MyImage
                  src={team?.oImg?.sUrl ? `${S3_PREFIX}${team?.oImg?.sUrl}` : TeamImage}
                  alt={team?.sAbbr}
                  placeholderImage={TeamImage}
                  width={40}
                  height={40}
                  layout="responsive"
                />
              </div>
              <div className="flex-grow-1">
                <h6 className={`${styles.name} font-bold`}>{team?.sTitle}</h6>
                <span className={`${styles.caption} font-bold`}>{team?.sCountryFull}</span>
              </div>
            </div>}
          </Col>)
      })}
    </Row>
  )
}

TeamCards.propTypes = {
  teamsList: PropTypes.array
}

export default TeamCards
